import equal from "fast-deep-equal";
import {
  FixedMixCreate,
  FixedMixRead,
  MixCreate,
} from "store/api/generatedApi";

export const editableFixedMixes = (mixes: FixedMixRead[]): FixedMixCreate[] =>
  mixes.map(({ steel_grade_name, mix, unobtainium_reporting }) => ({
    steel_grade_name,
    unobtainium_reporting,
    mix: {
      baskets: mix.baskets,
      furnace: mix.furnace,
      thresholds: mix.thresholds,
    },
  }));

export const fixedMixMatches = (left: MixCreate, right: MixCreate) =>
  equal(left, right);

export const fixedMixesMatch = (
  left: FixedMixCreate[],
  right: FixedMixCreate[]
) =>
  left.length === right.length &&
  left.every((recipe) => {
    const other = right.find(
      (candidate) => candidate.steel_grade_name === recipe.steel_grade_name
    );
    return other !== undefined && fixedMixMatches(recipe.mix, other.mix);
  });
